import { Typography, Stack, Chip } from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';
import { MEMBERSHIP_PLANS, MembershipPlan } from '../../membership.constants';

type CardContentProps =
  | {
      title: string;
      description: string;
    }
  | {
      title: string;
      plan: MembershipPlan;
      description: string;
      amount: number;
    };

export const CardContent = (props: CardContentProps): JSX.Element => {
  const { title, description } = props;
  const { t } = useTranslation();

  return (
    <Stack spacing={1}>
      <Stack spacing={2}>
        {'plan' in props && props.plan === MEMBERSHIP_PLANS.yearly && (
          <Chip
            label={t('supportUs.membership.chip')}
            color="brand"
            component="span"
            variant="watchduty"
          />
        )}

        <Stack
          direction="row"
          spacing={1}
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography variant="h2">{title}</Typography>

          {'amount' in props && (
            <Typography variant="body2" component="span">
              <Trans
                i18nKey={
                  props.plan === MEMBERSHIP_PLANS.yearly
                    ? 'supportUs.membership.price'
                    : 'supportUs.proMembership.price'
                }
                values={{
                  price: props.amount,
                }}
              >
                <Typography variant="h3" component="span" fontWeight={500}>
                  $24.99
                </Typography>
                / year
              </Trans>
            </Typography>
          )}
        </Stack>
      </Stack>

      <Typography variant="body1">{description}</Typography>
    </Stack>
  );
};
